module.exports = "<div class=\"header\">\n  <img class=\"logo pull-right\" src=\"/assets/images/helicat-logo.png\" />\n  <div class=\"title\">\n    <span>HeliCat Incident Reporting & Exchange (HIRE)</span>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/header/header.html
// module id = 46
// module chunks = 0